module.exports = __webpack_public_path__ + "img/Slice5-min.27221316.png";